import configData from "../../config";

export const OSOReportList = [
  {
    id: 1,
    label: "Discontinued Items",
    url: `${configData.ReportBasePath}Disco_POG_Items`,
  },
  {
    id: 2,
    label: "Department Totals & Discounting",
    url: `${configData.ReportBasePath}Planogram_Summary`,
  },
  {
    id: 3,
    label: "Planogram Notes By Department",
    url: `${configData.ReportBasePath}Planogram_Notes`,
  },
  {
    id: 4,
    label: "Item Quantity Details",
    url: `${configData.ReportBasePath}Item QTY Detail`,
  },
  {
    id: 5,
    label: "OSO Pending POs",
    url: `${configData.ReportBasePath}Pending Pos`,
  },
  {
    id: 6,
    label:
      "Planogram Exception - Items Removed/Ordered From Planogram From Selection Date",
    url: `${configData.ReportBasePath}POG_Exceptions`,
  },
  {
    id: 7,
    label: "OSO Credit Report",
    url: `${configData.ReportBasePath}OSO_Credit_Detail`,
  },
  {
    id: 8,
    label: "Planogram Order Quantity Exception Report",
    url: `${configData.ReportBasePath}POG_Order_Qty_Exceptions`,
  },
  {
    id: 9,
    label: "Planogram SKU Comparison Report",
    url: `${configData.ReportBasePath}Planogram_SKU_Comparison`,
  },
  {
    id: 10,
    label: "Selected Planogram Order Release Date",
    url: `${configData.ReportBasePath}Selected_POGS_Release_Dates`,
  },
  {
    id: 11,
    label: "Selected Existing Planogram Listing",
    url: `${configData.ReportBasePath}Select Exist POGs`,
  },
  {
    id: 12,
    label: "3rd Party POS Item Detail",
    url: `${configData.ReportBasePath}3rd Party POS Item Detail`,
  },
  {
    id: 13,
    label: "Released Order Planogram Report",
    url: `${configData.ReportBasePath}Released_Osos_ByYear`,
  },
  {
    id: 14,
    label: "IP File",
    url: `${configData.ReportBasePath}IP File`,
  },
  {
    id: 15,
    label: "Planogram Summary with Notes",
    url: `${configData.ReportBasePath}POG_Summary_ w_ Notes`,
  },
  {
    id: 16,
    label: "Purchase History & Store Inventory Toggle History",
    url: `${configData.ReportBasePath}PH-SI History Report`,
  },
];

export const SSReportList = [
  {
    id: 1,
    label: "Bill Of Material (BOM)",
    url: `${configData.ReportBasePath}Bill of Material`,
  },
  {
    id: 2,
    label: "Bill Of Material (BOM) - Summary",
    url: `${configData.ReportBasePath}Bill of Material Summary`,
  },
  {
    id: 3,
    label: "Drop Ship",
    url: `${configData.ReportBasePath}DS Racks POP`,
  },
  {
    id: 4,
    label: "Warehouse Racks",
    url: `${configData.ReportBasePath}WareHouse Racks`,
  },
  {
    id: 5,
    label: "Warehouse Racks - Summary",
    url: `${configData.ReportBasePath}WareHouse Racks Summary`,
  },
  {
    id: 6,
    label: "Store Supplies - Free Items",
    url: `${configData.ReportBasePath}StoreSupplies Free Items`,
  },
  {
    id: 7,
    label: "Store Supplies - Items with Department 95",
    url: `${configData.ReportBasePath}StoreSupplies Items Under EMS DPT 95`,
  },
  {
    id: 8,
    label: "Store Supplies - Items without Department 95",
    url: `${configData.ReportBasePath}StoreSupplies Items Without EMS DPT 95`,
  },
];
